import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/hospedajes/';

/**
 * GET Hospedajes
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getHospedajes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Hospedaje
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getHospedaje = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Hospedaje
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postHospedaje = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Hospedaje
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchHospedaje = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Hospedaje
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteHospedaje = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Hospedaje
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosHospedaje = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Hospedaje para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
// TODO: Agregar El endpoint para obtener los hospedajes para la caja
export const getHospedajeCaja = async (params = null) => {
  try {
    const response = await API.get('empresas/hospedaje-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
